/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomRelationshipsItem/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Avatar from './Avatar/index'
import Delete from './Delete/index'
import Edit from './Edit/index'
import IsPatient from './IsPatient/index'
import Menu from './Menu/index'
import PersonDetails from './PersonDetails/index'
import React from 'react'
import Type from './Type/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import ViewDetails from './ViewDetails/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomRelationshipsItem({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let relationshipPermittedToSeeInfoValueData = fromData.useDataValue({ viewPath,
context: 'relationship',
path: 'permitted_to_see_info',
})
  return (<React.Fragment
>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<ViewDetails
  viewPath={`${viewPath}/ViewDetails`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
<div
  data-testid="DataVaxiomRelationshipsItem.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-1J2b1S': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-1J2b1S': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-1J2b1S': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-1J2b1S': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="DataVaxiomRelationshipsItem.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="DataVaxiomRelationshipsItem.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
/>
<div
  data-testid="DataVaxiomRelationshipsItem.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-5-1J2b1S': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<PersonDetails
  viewPath={`${viewPath}/PersonDetails`}
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
<div
  data-testid="DataVaxiomRelationshipsItem.Vertical:2"
  data-view-path={viewPath}
 style={{'--ml-5-1J2b1S': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-6-1J2b1S': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical2}`}
>
<fromFlow.When is={relationshipPermittedToSeeInfoValueData}>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 data="relationship.permitted_to_see_info"
 type="grey"
 style="filled"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Permitted to see info"
/>
)}
</TysiaTag>
</fromFlow.When>
</div>
</button>
</div>
<div
  data-testid="DataVaxiomRelationshipsItem.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<IsPatient
  viewPath={`${viewPath}/IsPatient`}
/>
</div>
<div
  data-testid="DataVaxiomRelationshipsItem.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
>
<Menu
  viewPath={`${viewPath}/Menu`}
/>
</div>
</div>
{children}
</React.Fragment>)
}